import React from 'react';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import translations from '../../languages/i18n';

export default function MonthDataTable({ data, month }) {  
  let total =0;
    const monthData = data.find((obj) => obj.date == month);
    return (
      <Paper  style={{width: '100%'}}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan='2' style={{fontWeight: 'bold', textAlign: 'center'}}>{monthData.date}</TableCell>              
            </TableRow>
            <TableRow>
              <TableCell style={{fontWeight: 'bold'}}>{translations['_program']}</TableCell>
              <TableCell style={{fontWeight: 'bold'}}>{translations['_numEnrolled']}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>          
            {Object.entries(monthData).map(([key, value]) => {
              if (key !== 'date') {
                total = total + value;
                return (
                  <TableRow key={key} hover>
                    <TableCell>{key}</TableCell>
                    <TableCell>{value}</TableCell>
                  </TableRow>
                )
              }
            })}
            <TableRow>
              <TableCell style={{fontWeight: 'bold', textAlign: 'right'}}>{translations['_total']}</TableCell>
              <TableCell>{total}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    )
}

// Indica i controla els props que se han de passar al component
MonthDataTable.propTypes = {
  data: PropTypes.array.isRequired,
  month: PropTypes.string.isRequired,
};
